import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const Button = ({
  text = '',
  type = 'submit',
  color = 'primary',
  extraClassName = '',
  isLoading = false,
  ...props
}) => (
  <button
    className={classnames('btn', extraClassName, `btn-${color}`, {
      'is-loading disabled': isLoading,
    })}
    type={type}
    {...props}
  >
    {text}
  </button>
);

Button.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['submit', 'button', 'reset']),
  color: PropTypes.oneOf([
    'primary',
    'info',
    'success',
    'danger',
    'warning',
    'secondary',
    'dark',
    'light',
    'link',
    'outline-primary',
    'outline-info',
    'outline-success',
    'outline-danger',
    'outline-warning',
    'outline-secondary',
    'outline-dark',
    'outline-light',
    'outline-link',
  ]),
  extraClassName: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default Button;



// WEBPACK FOOTER //
// src/modules/common/components/form/Button.js